import React from 'react';

import TGT from '../component/TeachersGridTest'

const TestPage = () =>  <TGT/>;

export default TestPage;